var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgItaly = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 800,
  height: 800
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M516.129 245.161v-90.322H283.871v490.322h232.258V296.774c0-7.126 5.777-12.903 12.903-12.903v-25.807c-7.126 0-12.903-5.777-12.903-12.903z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#259245",
  d: "M24.807 153.839h234.258v492.322H24.807z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#259245",
  d: "M25.807 154.839h232.258v490.322H25.807z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ED1F34",
  d: "M540.936 646.161V296.774c0-6.563-5.34-11.903-11.903-11.903h-1v-27.807h1c6.563 0 11.903-5.34 11.903-11.903v-91.322h234.258v492.322H540.936z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ED1F34",
  d: "M541.936 245.161c0 7.126-5.777 12.903-12.903 12.903v25.807c7.126 0 12.903 5.777 12.903 12.903v348.387h232.258V154.839H541.936v90.322z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M787.097 129.032H12.903C5.777 129.032 0 134.81 0 141.936v516.129c0 7.126 5.777 12.903 12.903 12.903h774.193c7.126 0 12.903-5.777 12.903-12.903V141.936c.001-7.126-5.776-12.904-12.902-12.904zm-12.904 516.129H541.936V296.774c0-7.126-5.777-12.903-12.903-12.903s-12.903 5.777-12.903 12.903v348.387H283.871V154.839h232.258v90.322c0 7.126 5.777 12.903 12.903 12.903s12.903-5.777 12.903-12.903v-90.322h232.258v490.322zM25.807 154.839h232.258v490.322H25.807V154.839z"
})));
export default SvgItaly;